import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "booking-adjust-v4-page-root",
  "data-testid": "booking-adjust-v4-page-root",
  class: "flex flex-col h-full relative overflow-hidden"
}
const _hoisted_2 = { id: "booking-adjust-v4-header-slot" }
const _hoisted_3 = {
  key: 1,
  class: "flex-1 min-h-0 overflow-y-auto bg-gray-lp-1200"
}
const _hoisted_4 = { class: "flex flex-row items-start gap-3 p-3" }
const _hoisted_5 = {
  id: "booking-adjust-v4-form-main-column",
  "data-testid": "booking-adjust-v4-form-main-column",
  class: "flex-1 min-w-0 flex flex-col gap-y-2"
}
const _hoisted_6 = {
  id: "booking-v4-section-sender",
  "data-testid": "booking-adjust-v4-section-sender",
  class: "flex-shrink-0 min-w-0",
  style: {"flex-basis":"38%"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col items-center justify-between py-1.5 flex-none",
  style: {"gap":"4px"}
}, [
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("div", { class: "flex-1 border-l-2 border-dashed border-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" })
], -1)
const _hoisted_8 = {
  id: "booking-v4-section-receiver",
  "data-testid": "booking-adjust-v4-section-receiver",
  class: "flex-1 min-w-0"
}
const _hoisted_9 = { id: "booking-v4-section-reference-number" }
const _hoisted_10 = {
  id: "booking-v4-section-product-type",
  class: "mb-2"
}
const _hoisted_11 = {
  id: "booking-adjust-v4-sticky-sidebar",
  "data-testid": "booking-v4-sticky-sidebar",
  class: "shrink-0 sticky top-0",
  style: {"width":"350px"}
}
const _hoisted_12 = {
  class: "p-3",
  "data-testid": "booking-adjust-v4-form-completion"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "border-b border-t border-gray-lp-1600 p-3" }, null, -1)
const _hoisted_14 = { class: "p-3 flex flex-col gap-y-2 " }
const _hoisted_15 = { class: "border-t border-gray-lp-1600  flex flex-col gap-y-2 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_HeaderEditBookingV4 = _resolveComponent("HeaderEditBookingV4")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_SenderSectionV4 = _resolveComponent("SenderSectionV4")!
  const _component_ReceiverSectionV4 = _resolveComponent("ReceiverSectionV4")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ReferenceNumberV4 = _resolveComponent("ReferenceNumberV4")!
  const _component_GoodsPackageV4 = _resolveComponent("GoodsPackageV4")!
  const _component_SectionUploadPhotoForWeightAdjustmentV4 = _resolveComponent("SectionUploadPhotoForWeightAdjustmentV4")!
  const _component_SupportingDocSectionV4 = _resolveComponent("SupportingDocSectionV4")!
  const _component_ProductCardListV4 = _resolveComponent("ProductCardListV4")!
  const _component_FormCompletionPanel = _resolveComponent("FormCompletionPanel")!
  const _component_PaymentMethodSelectorV4 = _resolveComponent("PaymentMethodSelectorV4")!
  const _component_ProtectionPackingSummary = _resolveComponent("ProtectionPackingSummary")!
  const _component_TotalTarifSectionV4 = _resolveComponent("TotalTarifSectionV4")!
  const _component_BookingStickyFooterV4 = _resolveComponent("BookingStickyFooterV4")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalSuccessBookingV4 = _resolveComponent("ModalSuccessBookingV4")!
  const _component_ModalFailedBookingV4 = _resolveComponent("ModalFailedBookingV4")!
  const _component_ModalPreviewInvoice = _resolveComponent("ModalPreviewInvoice")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoadingPage)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderEditBookingV4, {
          activeTab: _ctx.activeTab,
          receiptFormat: _ctx.receiptFormat,
          "onUpdate:activeTab": _ctx.onActiveTabUpdate,
          "onUpdate:receiptFormat": _ctx.onReceiptFormatUpdate
        }, null, 8, ["activeTab", "receiptFormat", "onUpdate:activeTab", "onUpdate:receiptFormat"])
      ]),
      (_ctx.isError)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorDetail,
            onTryAgain: _ctx.fetchAdjustDetailData
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Card, {
                  rounded: "xl",
                  class: "flex items-stretch p-4 gap-x-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode(_component_SenderSectionV4, {
                        modelValue: _ctx.bookingFormV4,
                        "onUpdate:modelValue": _ctx.onSenderUpdate,
                        errors: _ctx.errors,
                        "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors = $event)),
                        currentIndex: _ctx.currentIndex,
                        showClientField: _ctx.showClientField,
                        selectedClient: _ctx.clientMetaV4.selectedClient,
                        "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                        senderCountryIndex: _ctx.senderCountryIndex,
                        senderNameIndex: _ctx.senderNameIndex,
                        senderPhoneIndex: _ctx.senderPhoneIndex,
                        senderAddressIndex: _ctx.senderAddressIndex,
                        activeTab: _ctx.activeTab,
                        configName: _ctx.configRule.senderName,
                        configPhone: _ctx.configRule.senderPhone,
                        configAddress: _ctx.configRule.senderAddress,
                        isClientDisabled: true,
                        configDistrict: _ctx.configRule.senderDistrict,
                        isEdit: true,
                        class: "mb-2",
                        onAutofillCommodity: _ctx.onAutofillCommodity,
                        onValidationChange: _ctx.onSenderValidationChange
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "currentIndex", "showClientField", "selectedClient", "onUpdate:currentIndex", "senderCountryIndex", "senderNameIndex", "senderPhoneIndex", "senderAddressIndex", "activeTab", "configName", "configPhone", "configAddress", "configDistrict", "onAutofillCommodity", "onValidationChange"])
                    ]),
                    _hoisted_7,
                    _createVNode("div", _hoisted_8, [
                      _createVNode(_component_ReceiverSectionV4, {
                        modelValue: _ctx.bookingFormV4,
                        "onUpdate:modelValue": _ctx.onReceiverUpdate,
                        errors: _ctx.errors,
                        "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors = $event)),
                        currentIndex: _ctx.currentIndex,
                        "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                        receiverCountryIndex: _ctx.receiverCountryIndex,
                        receiverNameIndex: _ctx.receiverNameIndex,
                        receiverPhoneIndex: _ctx.receiverPhoneIndex,
                        receiverAddressIndex: _ctx.receiverAddressIndex,
                        receiverDistrictIndex: _ctx.receiverDistrictIndex,
                        receiverPostalCodeIndex: _ctx.receiverPostalCodeIndex,
                        activeTab: _ctx.activeTab,
                        isForeign: _ctx.isAccountForeignPos,
                        isErrorEmbargo: _ctx.isErrorEmbargoDestination,
                        isErrorRouteNotFound: _ctx.errorRouteNotFound,
                        "onUpdate:isErrorRouteNotFound": _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorRouteNotFound = $event)),
                        configName: _ctx.configRule.recipientName,
                        configPhone: _ctx.configRule.recipientPhone,
                        configAddress: _ctx.configRule.recipientAddress,
                        configDistrict: _ctx.configRule.recipientDistrict,
                        configCountry: _ctx.configRule.recipientCountry,
                        configPostalCode: _ctx.configRule.recipientPostalCode,
                        isPostalCodeRequired: false,
                        class: "mb-2",
                        onValidationChange: _ctx.onReceiverValidationChange,
                        preserveDistrictOnPostalClear: _ctx.isBookingShipment
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "currentIndex", "onUpdate:currentIndex", "receiverCountryIndex", "receiverNameIndex", "receiverPhoneIndex", "receiverAddressIndex", "receiverDistrictIndex", "receiverPostalCodeIndex", "activeTab", "isForeign", "isErrorEmbargo", "isErrorRouteNotFound", "configName", "configPhone", "configAddress", "configDistrict", "configCountry", "configPostalCode", "onValidationChange", "preserveDistrictOnPostalClear"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  rounded: "xl",
                  class: "flex items-stretch p-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_ReferenceNumberV4, {
                        modelValue: _ctx.bookingFormV4.references,
                        "onUpdate:modelValue": _ctx.onReferencesUpdate,
                        errors: _ctx.errors,
                        "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors = $event)),
                        formContext: "retail",
                        accountType: _ctx.accountType,
                        isRequired: _ctx.isReferenceRequired,
                        selectedClient: _ctx.clientMetaV4.selectedClient,
                        maxItems: 3,
                        configManualSttNo: _ctx.configRule.manualSttNo,
                        configSttNoRefExternal: _ctx.configRule.sttNoRefExternal,
                        configShipmentId: _ctx.configRule.shipmentId,
                        onValidationChange: _ctx.onReferenceValidationChange,
                        onFocusin: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(9)))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "accountType", "isRequired", "selectedClient", "configManualSttNo", "configSttNoRefExternal", "configShipmentId", "onValidationChange"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  rounded: "xl",
                  class: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", {
                      id: "booking-v4-section-goods-pieces",
                      "data-testid": "booking-adjust-v4-section-goods-package",
                      class: "p-4",
                      onFocusin: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(11)))
                    }, [
                      (!_ctx.isLoadingPage)
                        ? (_openBlock(), _createBlock(_component_GoodsPackageV4, {
                            key: 0,
                            ref: "goodsPackageRef",
                            showItemDetails: _ctx.showItemDetails,
                            showResetButton: false,
                            isFtz: _ctx.isFtzForm,
                            localCurrency: _ctx.formAccountCurrencyCode,
                            currencyPrefix: _ctx.formAccountCurrencyPrefix,
                            numericLocale: _ctx.formAccountCurrencyCode === 'MYR' ? 'my' : 'id',
                            isForeign: _ctx.isForeignAccount,
                            commodityCipl: _ctx.bookingFormV4.commodityCipl,
                            ciplCommodities: _ctx.ciplCommodityOptions,
                            estimatedConversion: _ctx.ciplEstimatedConversion,
                            deminimisThreshold: _ctx.ciplDeminimisThreshold,
                            deminimisExceeded: _ctx.ciplDeminimisExceeded,
                            destinationCurrencyCode: _ctx.dutyTaxDestinationCurrency,
                            recipientImportDocRequired: _ctx.recipientImportDocRequired,
                            selfClearanceRequired: _ctx.selfClearanceRequired,
                            commodity: _ctx.bookingFormV4.commodity,
                            commodities: _ctx.commoditySearchResults,
                            recommendedCommodities: _ctx.commodityRecommendations,
                            errors: _ctx.errors,
                            loading: _ctx.commodityListLoading,
                            hasMore: _ctx.commodityListHasMore,
                            modalSearchResults: _ctx.modalSearchResults,
                            commodityCategories: _ctx.commodityCategories,
                            commodityCategoryItems: _ctx.commodityCategoryItems,
                            selectedCategoryCode: _ctx.selectedCategoryCode,
                            modalLoading: _ctx.commodityModalLoading,
                            modalLoadingCategory: _ctx.commodityModalLoadingCategory,
                            modalHasMore: _ctx.commodityModalHasMore,
                            pieces: _ctx.bookingFormV4.pieces,
                            volumeWeightDivisor: _ctx.volumeWeightDivisorForSelectedProduct,
                            hwsConfig: _ctx.hwsConfigForSelectedProduct,
                            maxPieces: _ctx.maxGoodsPieces,
                            singlePieceOnly: _ctx.receiverSinglePieceOnly,
                            configCommodity: _ctx.configRule.commodity,
                            configGoodsPrice: _ctx.configRule.goodsPrice,
                            configGrossWeight: _ctx.configRule.grossWeight,
                            configDimension: _ctx.configRule.dimension,
                            configAdjustPieceAdd: _ctx.configRule.adjustPieceAdd,
                            configAdjustPieceRemove: _ctx.configRule.adjustPieceRemove,
                            configCipl: _ctx.ciplAdjustmentRule,
                            isShowSectionUpload: _ctx.isShowSectionUpload,
                            disabledWeightAdjustment: _ctx.isWeightAdjustmentPhotoMissing,
                            minWeightThreshold: _ctx.manualBookingData.sttTotalChargeAbleWeight,
                            isEdit: true,
                            showSavePackageCheckbox: false,
                            "onUpdate:commodityCipl": _ctx.onCommodityCiplUpdate,
                            "onUpdate:commodity": _ctx.onCommodityUpdate,
                            "onUpdate:pieces": _ctx.onPiecesUpdate,
                            onReset: _ctx.onGoodsPackageReset,
                            onCiplValidationChange: _ctx.onCiplValidationChange,
                            onCommodityValidationChange: _ctx.onCommodityValidationChange,
                            onPackageWeightValidationChange: _ctx.onPackageWeightValidationChange,
                            onGrossWeightChange: _ctx.getEstimationPriceDebounced,
                            onSearchCommodity: _ctx.searchCommodity,
                            onLoadMoreCommodities: _ctx.loadMoreCommodities,
                            onSearchCommodityModal: _ctx.searchCommodityModal,
                            onLoadMoreCommodityModal: _ctx.loadMoreCommodityModal,
                            onSelectCommodityCategory: _ctx.selectCommodityCategory,
                            onCommodityError: _ctx.onCommodityError
                          }, null, 8, ["showItemDetails", "isFtz", "localCurrency", "currencyPrefix", "numericLocale", "isForeign", "commodityCipl", "ciplCommodities", "estimatedConversion", "deminimisThreshold", "deminimisExceeded", "destinationCurrencyCode", "recipientImportDocRequired", "selfClearanceRequired", "commodity", "commodities", "recommendedCommodities", "errors", "loading", "hasMore", "modalSearchResults", "commodityCategories", "commodityCategoryItems", "selectedCategoryCode", "modalLoading", "modalLoadingCategory", "modalHasMore", "pieces", "volumeWeightDivisor", "hwsConfig", "maxPieces", "singlePieceOnly", "configCommodity", "configGoodsPrice", "configGrossWeight", "configDimension", "configAdjustPieceAdd", "configAdjustPieceRemove", "configCipl", "isShowSectionUpload", "disabledWeightAdjustment", "minWeightThreshold", "onUpdate:commodityCipl", "onUpdate:commodity", "onUpdate:pieces", "onReset", "onCiplValidationChange", "onCommodityValidationChange", "onPackageWeightValidationChange", "onGrossWeightChange", "onSearchCommodity", "onLoadMoreCommodities", "onSearchCommodityModal", "onLoadMoreCommodityModal", "onSelectCommodityCategory", "onCommodityError"]))
                        : _createCommentVNode("", true)
                    ], 32)
                  ]),
                  _: 1
                }),
                (_ctx.isShowSectionUpload)
                  ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjustmentV4, {
                      key: 0,
                      ref: "section-weight-adjustment",
                      watermark: _ctx.manualBookingData.sttNo,
                      modelValue: _ctx.attachmentImages,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.attachmentImages = $event)),
                      onOnUploadImage: _ctx.onUploadWeightAdjustment,
                      onOnDeleteImage: _ctx.onRemoveWeightAdjustment
                    }, null, 8, ["watermark", "modelValue", "onOnUploadImage", "onOnDeleteImage"]))
                  : _createCommentVNode("", true),
                (_ctx.showSupportingDocSection)
                  ? (_openBlock(), _createBlock(_component_SupportingDocSectionV4, {
                      key: 1,
                      modelValue: _ctx.bookingFormV4.supportingDoc,
                      isFtz: _ctx.isFtzForm,
                      isCipl: _ctx.isCipl,
                      fieldRules: _ctx.supportingDocFieldRules,
                      configRules: _ctx.supportingDocAdjustRules,
                      showRequiredImageErrors: _ctx.hasAttemptedSubmit,
                      errors: _ctx.errors,
                      "onUpdate:modelValue": _ctx.onSupportingDocUpdate,
                      onValidationChange: _ctx.onSupportingDocValidationChange,
                      onFocusin: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(20))),
                      isRetail: _ctx.isBookingRetail && !_ctx.isInternalAccount,
                      isEdit: !_ctx.isInternalAccount
                    }, null, 8, ["modelValue", "isFtz", "isCipl", "fieldRules", "configRules", "showRequiredImageErrors", "errors", "onUpdate:modelValue", "onValidationChange", "isRetail", "isEdit"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Card, {
                  rounded: "xl",
                  class: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_ProductCardListV4, {
                        modelValue: _ctx.bookingFormV4.product.productType,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => (_ctx.bookingFormV4.product.productType = $event)),
                          _ctx.onProductTypeSelect
                        ],
                        products: _ctx.productCardItems,
                        showAgentDiscountToggle: _ctx.shouldShowAgentDiscountToggle,
                        agentDiscountRevealed: _ctx.isAgentDiscountRevealed,
                        agentDiscountToggleEnabled: _ctx.isSuperAdminBooking,
                        loading: _ctx.productUpsellingLoading,
                        isError: _ctx.productUpsellingIsError,
                        currencyPrefix: _ctx.formCurrencyPrefix,
                        configProductType: _ctx.configRule.productType,
                        configTariff: _ctx.configRule.tariff,
                        isClient: _ctx.isPriceMaskedTariff,
                        hideDiscount: _ctx.isSttBookedForClient,
                        "onUpdate:agentDiscountRevealed": _ctx.onAgentDiscountRevealedUpdate,
                        onRetry: _ctx.onProductUpsellingRetry
                      }, null, 8, ["modelValue", "products", "showAgentDiscountToggle", "agentDiscountRevealed", "agentDiscountToggleEnabled", "loading", "isError", "currencyPrefix", "configProductType", "configTariff", "isClient", "hideDiscount", "onUpdate:modelValue", "onUpdate:agentDiscountRevealed", "onRetry"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("aside", _hoisted_11, [
                _createVNode(_component_Card, {
                  rounded: "xl",
                  class: "flex flex-col gap-y-2 items-stretch "
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_FormCompletionPanel, {
                        items: _ctx.formCompletionItems,
                        onNavigate: _ctx.onFormCompletionNavigate
                      }, null, 8, ["items", "onNavigate"])
                    ]),
                    _hoisted_13,
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_PaymentMethodSelectorV4, {
                        "data-testid": "booking-adjust-v4-payment-locked",
                        paymentMethod: _ctx.bookingFormV4.paymentMethod,
                        paymentMethodOptions: _ctx.paymentMethodOptions,
                        currencyPrefix: _ctx.formCurrencyPrefix,
                        isReadonly: true,
                        form: _ctx.bookingFormV4,
                        "onUpdate:paymentMethod": _ctx.onPaymentMethodUpdate
                      }, null, 8, ["paymentMethod", "paymentMethodOptions", "currencyPrefix", "form", "onUpdate:paymentMethod"]),
                      _createVNode(_component_ProtectionPackingSummary, {
                        modelValue: _ctx.bookingFormV4,
                        protectionPacking: _ctx.bookingFormV4.protectionPacking,
                        currencyPrefix: _ctx.goodsPriceCurrencyPrefix,
                        numericLocale: _ctx.formNumericLocale,
                        isCrossCountryCod: _ctx.isCrossCountryCod,
                        agentDiscountCommission: _ctx.agentDiscountCommission,
                        itemPriceError: _ctx.errors.itemPrice,
                        insuranceBasic: _ctx.insuranceBasic,
                        isInsuranceVisible: _ctx.insuranceBasic.isAvailable,
                        configInsurance: _ctx.configRule.insurance,
                        configCodAmount: _ctx.configRule.codAmount,
                        configGoodsPrice: _ctx.configRule.goodsPrice,
                        configWoodpacking: _ctx.configRule.woodpacking,
                        paymentMethod: _ctx.bookingFormV4.paymentMethod,
                        isShowCODAmountField: _ctx.isShowCODAmountField,
                        "onUpdate:protectionPacking": _ctx.onProtectionPackingUpdate,
                        showAgentDiscount: !_ctx.isSttBookedForClient,
                        onBlurItemPrice: _ctx.onItemPriceBlur
                      }, null, 8, ["modelValue", "protectionPacking", "currencyPrefix", "numericLocale", "isCrossCountryCod", "agentDiscountCommission", "itemPriceError", "insuranceBasic", "isInsuranceVisible", "configInsurance", "configCodAmount", "configGoodsPrice", "configWoodpacking", "paymentMethod", "isShowCODAmountField", "onUpdate:protectionPacking", "showAgentDiscount", "onBlurItemPrice"])
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_BookingStickyFooterV4, {
                        chargeableWeightKg: _ctx.footerChargeableWeightKg,
                        totalKoli: _ctx.bookingFormV4.protectionPacking.totalKoli,
                        chargeableWeightExpanded: 
                  _ctx.bookingFormV4.protectionPacking.chargeableWeightExpanded
                ,
                        "onUpdate:chargeableWeightExpanded": _cache[10] || (_cache[10] = ($event: any) => (
                  _ctx.bookingFormV4.protectionPacking.chargeableWeightExpanded
                 = $event)),
                        chargeableWeightBreakdown: _ctx.chargeableWeightBreakdown,
                        woodpacking: _ctx.bookingFormV4.protectionPacking.woodpacking,
                        "onUpdate:protectionPacking": 
                  _ctx.onProtectionPackingUpdateFromCwFooter
                
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TotalTarifSectionV4, {
                            estimationPrice: _ctx.bookingFormV4.estimationPrice,
                            currencyPrefix: _ctx.formCurrencyPrefix,
                            codCurrencyPrefix: _ctx.goodsPriceCurrencyPrefix,
                            codCurrencyCode: _ctx.goodsPriceCurrencyCode,
                            paymentMethod: _ctx.bookingFormV4.paymentMethod,
                            itemPrice: _ctx.bookingFormV4.protectionPacking.itemPrice,
                            woodpacking: _ctx.bookingFormV4.protectionPacking.woodpacking,
                            protectionChecked: 
                    _ctx.bookingFormV4.protectionPacking.protectionChecked
                  ,
                            isFtz: _ctx.isFtz,
                            isLoading: _ctx.estimationLoading,
                            isError: _ctx.estimationIsError,
                            canOpenDetail: _ctx.canOpenDetailTariff,
                            isPriceMasked: _ctx.isPriceMaskedTariff,
                            onRefresh: _ctx.onTariffRefresh,
                            isRetail: "",
                            hideCodReturnFee: !(_ctx.isSttBookedForPos || _ctx.isCaPrefix)
                          }, null, 8, ["estimationPrice", "currencyPrefix", "codCurrencyPrefix", "codCurrencyCode", "paymentMethod", "itemPrice", "woodpacking", "protectionChecked", "isFtz", "isLoading", "isError", "canOpenDetail", "isPriceMasked", "onRefresh", "hideCodReturnFee"])
                        ]),
                        _: 1
                      }, 8, ["chargeableWeightKg", "totalKoli", "chargeableWeightExpanded", "chargeableWeightBreakdown", "woodpacking", "onUpdate:protectionPacking"]),
                      _createVNode(_component_LpButton, {
                        class: "mt-4",
                        title: _ctx.$t('bookingV4.footer.bookingAction'),
                        color: "red-lp-2400",
                        textColor: "white",
                        isWidthFull: "",
                        fontWeight: "semibold",
                        "data-testid": "booking-adjust-v4-submit",
                        tabAccessible: "",
                        onClick: _ctx.onSubmit
                      }, null, 8, ["title", "onClick"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])),
      (_ctx.isSuccessModalVisible)
        ? (_openBlock(), _createBlock(_component_ModalSuccessBookingV4, {
            key: 2,
            data: _ctx.successBookingData,
            receiptFormat: _ctx.bookingFormV4.pageMeta.receiptFormat,
            isButtonCreateInvoice: false,
            totalPieces: _ctx.bookingFormV4.pieces.length,
            selectedClient: _ctx.clientMetaV4.selectedClient,
            bookingClient: !!_ctx.clientMetaV4.selectedClient?.clientId,
            isCrossCountryCod: _ctx.isCrossCountryCod,
            prefixCurrency: _ctx.goodsPriceCurrencyPrefix,
            onClose: _ctx.onCloseSuccessModal,
            onPrint: _ctx.onPrintSuccessReceipt
          }, null, 8, ["data", "receiptFormat", "totalPieces", "selectedClient", "bookingClient", "isCrossCountryCod", "prefixCurrency", "onClose", "onPrint"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ModalFailedBookingV4, _mergeProps({
        modelValue: _ctx.isShowModalFailedBooking,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isShowModalFailedBooking = $event))
      }, _ctx.modalFailedBookingData, {
        onReload: _ctx.onSubmit,
        onScrollToDestination: _cache[12] || (_cache[12] = ($event: any) => (
        _ctx.onFormCompletionNavigate(_ctx.formCompletionSectionKeyV4.RECEIVER)
      )),
        onScrollToCod: _cache[13] || (_cache[13] = ($event: any) => (
        _ctx.onFormCompletionNavigate(_ctx.formCompletionSectionKeyV4.PAYMENT_METHOD)
      )),
        onScrollToCommodity: _cache[14] || (_cache[14] = ($event: any) => (
        _ctx.onFormCompletionNavigate(_ctx.formCompletionSectionKeyV4.GOODS_PIECES)
      ))
      }), null, 16, ["modelValue", "onReload"]),
      _createVNode(_component_ModalPreviewInvoice)
    ], 512), [
      [_vShow, !_ctx.isLoadingPage]
    ])
  ], 64))
}